import { FC } from "react";

import OrderDataContextProvider, { TOrderContextProviderProps } from "./providers/OrderDataContextProvider";
import OrderFieldsLoadingProvider from "./providers/OrderFieldsLoadingProvider";

const OrderContextProvider: FC<TOrderContextProviderProps> = ({ children, ...props }) => (
  <OrderFieldsLoadingProvider>
    <OrderDataContextProvider {...props}>{children}</OrderDataContextProvider>
  </OrderFieldsLoadingProvider>
);

export default OrderContextProvider;
